import React from "react";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { FullWidthAnimation } from "@learningblocks/shared-components/lib/FullWidthAnimation";

import "./index.scss";

export default function Animation(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  return (
    <div className="ba-container" id="ba-container">
      <div
        className="ba-heading"
        style={{ display: props.data.heading === "" ? "none" : null }}
      >
        {parse(t(`${props.data.heading}.string`))}
      </div>
      <div
        className="ba-description"
        style={{ display: props.data.description === "" ? "none" : null }}
      >
        {t(`${props.data.description}.string`)}
      </div>
      <FullWidthAnimation
        src={props.data.animation.src}
        url={props.data.animation.url}
        altText={
          props.data.animation.altText
            ? t(`${props.data.animation.altText}.string`)
            : ""
        }
        caption={
          props.data.animation.caption
            ? t(`${props.data.animation.caption}.string`)
            : ""
        }
        loop={props.data.animation.loop}
        autoplay={props.data.animation.autoplay}
        preview={props.preview}
      />
    </div>
  );
}
